import {debounce} from "debounce"
import SweetScroll from 'sweet-scroll'

/**
 *　ブラウザ幅によってoffsetを更新
  */
const offsetUpdate = () => {
  if(window.innerWidth < 768) {// SP
    return -80;
  } else { // SP
    return -120;
  }
}

/**
 *　sweet-scroll.jsのインスタンス生成
  */
const scroller = new SweetScroll({
  trigger: "[data-scroll]",
  header: '[data-scroll-header]',
  easing: "easeInOutCubic",
  offset: offsetUpdate(), // ブラウザ幅を確認し、offsetを更新
});

// resize event
window.addEventListener('resize', debounce( () => {
  scroller.update({
    offset: offsetUpdate(), // ブラウザ幅を確認し、offsetを更新
  })
}, 50));

const clearLocationHash = () => {
  if(['/team/'].includes(window.location.pathname)){
    return; //hashクリアしないで終了
  }
  window.location.hash = '';
}

export function scrollToWithHash(hash){
  if(document.getElementById(hash.substr(1)) === null) return;
  scroller.to(hash, {
    // updateURL: 'replace'
  });
}

export function initPageScroll() {
  /**
   * 別ページへ遷移した際、hashが付与されている場合はその要素までスクロールする
   */
  const hash = window.location.hash;
  if (hash) {
    clearLocationHash();
    scrollToWithHash(hash);
  }
}

